module.exports = __webpack_public_path__ + "img/toyosatomimi no miko_sc1.cf42179c.png";